import React from 'react';

import { useDidMount } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { useHideScroll, useLogger, useModal } from '@hooks';

interface UnexpectedErrorProps {
	error: string; // injected by ErrorBoundary component
}

export const UnexpectedError: React.FC<UnexpectedErrorProps> = ({ error }) => {
	const { show } = useModal('genericError');
	const { disable } = useHideScroll();
	const logger = useLogger();

	useDidMount(() => {
		logger('UnexpectedError', error);

		disable();
		show();
	});

	return null;
};
